export const TYPEMAP = {
  BLOG: "Blog",
  HIGHLIGHT: "Highlight",
  NEWS: "News",
  USE_CASE: "Use Case",
};
